(function () {
  'use strict';

  // ----- Mobile menu -----
  var toggle = document.getElementById('navToggle');
  var nav = document.getElementById('mainNav');

  function closeMenu() {
    nav.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-label', 'Open menu');
  }

  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    });
    nav.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', closeMenu);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && nav.classList.contains('is-open')) {
        closeMenu();
        toggle.focus();
      }
    });
  }

  // ----- Header shadow on scroll -----
  var header = document.getElementById('siteHeader');
  function onScroll() {
    if (header) header.classList.toggle('is-scrolled', window.scrollY > 8);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  // ----- Footer year -----
  var year = document.getElementById('year');
  if (year) year.textContent = new Date().getFullYear();

  // ----- Quote form validation -----
  // Replace the submit handler with your form backend
  // (Shopify contact form, Formspree, HubSpot, etc.) when going live.
  var form = document.getElementById('quoteForm');
  var status = document.getElementById('formStatus');

  function setError(field, message) {
    var wrap = field.closest('.field');
    var existing = wrap.querySelector('.field-error');
    if (existing) existing.remove();
    wrap.classList.toggle('has-error', Boolean(message));
    field.removeAttribute('aria-invalid');
    field.removeAttribute('aria-describedby');
    if (message) {
      var id = field.id + '-error';
      var p = document.createElement('p');
      p.className = 'field-error';
      p.id = id;
      p.textContent = message;
      wrap.appendChild(p);
      field.setAttribute('aria-invalid', 'true');
      field.setAttribute('aria-describedby', id);
    }
  }

  function validate(field) {
    var value = field.value.trim();
    if (field.required && !value) {
      var label = field.closest('.field').querySelector('label').textContent;
      return 'Enter your ' + label.toLowerCase() + '.';
    }
    if (field.type === 'email' && value && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
      return 'Enter an email address like name@company.com.';
    }
    return '';
  }

  // Prefill category from ?category=... (links from product pages)
  var catField = form && form.querySelector('#qCat');
  if (catField) {
    var wanted = new URLSearchParams(window.location.search).get('category');
    if (wanted) {
      Array.prototype.forEach.call(catField.options, function (opt) {
        if (opt.text.toLowerCase() === wanted.toLowerCase()) catField.value = opt.value || opt.text;
      });
    }
  }

  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var firstInvalid = null;
      form.querySelectorAll('input, select, textarea').forEach(function (field) {
        var msg = validate(field);
        setError(field, msg);
        if (msg && !firstInvalid) firstInvalid = field;
      });

      if (firstInvalid) {
        status.textContent = 'Check the highlighted fields and send again.';
        firstInvalid.focus();
        return;
      }

      status.textContent = 'Sending…';
      form.submit();
    });

    form.querySelectorAll('input, select, textarea').forEach(function (field) {
      field.addEventListener('blur', function () {
        if (field.closest('.field').classList.contains('has-error')) {
          setError(field, validate(field));
        }
      });
    });
  }
})();

/* Shopify: browser validation off (we validate), and mark the current page in the menu */
(function () {
  var f = document.getElementById('quoteForm');
  if (f) f.noValidate = true;
  var path = window.location.pathname.replace(/\/$/, '') || '/';
  var productPages = ['/pages/products', '/pages/meats', '/pages/seafood', '/pages/dairy', '/pages/pantry', '/pages/beverages'];
  document.querySelectorAll('.main-nav a[href]').forEach(function (a) {
    var href = a.getAttribute('href').split('?')[0];
    if (href === path || (href === '/pages/products' && productPages.indexOf(path) > -1)) a.setAttribute('aria-current', 'page');
  });
  if (/contact_posted=true/.test(window.location.search)) {
    var s = document.getElementById('formStatus');
    if (s) s.scrollIntoView({ block: 'center' });
  }
})();
